import AnnotationInfoType from "./enums/AnnotationInfoType";

class AnnotationInfo {
  constructor(
    public file: number,
    public type: AnnotationInfoType,
    public id?: number | undefined,
    public annotation_info_name?: string | undefined,
    public id_annotation?: number | undefined,
    public created_on?: string | undefined
  ) {}

  public static EmptyInstance(): AnnotationInfo {
    return new AnnotationInfo(-1, AnnotationInfoType.SOUND);
  }
}

export default AnnotationInfo;
